<template>
     <component :is="modalProgrammatic ? 'div' : 'o-modal'"
      :active="isActive"
      :canCancel="false"
      class="modal-sm"
      >
    <div class="modal-card">
      <header class="modal-card-head"> 
        <h4 class="modal-card-title  is-italic has-text-weight-semibold" >
           Create Shipping Order
          <span class="line-height required-label has-text-dark is-size-5 is-italic is-pulled-right mr-0 has-text-weight-normal">
            * required
          </span>
        </h4>
      </header>
      <div class="modal-card-body is-visible has-background-white px-0 pt-0">
        <div class="column pt-2">
          <div class="columns mb-0">
            <div class="column">
              <div class="field">
              <div class="field-label">
                <label class="label is-size-3 is-italic has-text-weight-semibold"> Shipping Order Name * </label>
              </div>
              <div class="field-body">
                <div class="control">
                    <input class="input" v-model.trim="orderName"
                      placeholder="Enter name (3 or more characters)">
                  </div>
              </div>
            </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <h4 class="is-size-3 is-italic has-text-weight-semibold">
                  Origin Details
              </h4>
            </div>
            <div class="column">
              <h4 class="is-size-3 is-italic has-text-weight-semibold">
                  Destination Details
              </h4>  
            </div>
          </div>
        </div>
        <div class="column pt-0">
          <div class="columns">
            <div class="column pt-0">
              <div :class="$store.state.activeScreen === 'inventory' ? 'mb-3' : 'mb-2'">
                <field-project-select
                    titleLabel="Project*"
                    :value="delivery.sourceProject"
                    :isEditing="true"
                    :options="sourceProjectList"
                    @select="setSourceProject"
                    :isDisabled="disabledFromInv"
                    :key="delivery.sourceProject._id"
                  >
                  </field-project-select>
              </div> 
              
             <div :class="$store.state.activeScreen === 'inventory' ? 'mb-3' : 'mb-2'">
                <field-location-select
                  titleLabel="Location*"
                  :isEditing="true"
                  :value="delivery.sourceLocation"
                  :options="sourceLocationList[delivery.sourceProject._id]"
                  v-model="delivery.sourceLocation"
                  @update:value="(val)=> delivery.sourceLocation = val"
                  :isDisabled="disabledFromInv"
                ></field-location-select>
              </div> 
              <div>
                <field-user-select
                titleLabel="Owner/Sender*"
                :isEditing="true"            
                :options="ownerList"
                :value="owner"
                v-model="owner"
                :key="ownerList.length"
                @update:value="(val)=> owner = val"
                ></field-user-select>
              </div>
            </div>

            <div class="column pt-0">
              <div class="mb-2">
                <field-project-select
                  titleLabel="Project*"
                  :value="delivery.destinationProject"
                  :options="destinationProjectList"
                  @select="setDestinationProject"
                  :isEditing="true"
                  :key="destinationProjectList.length"
                  
                >
                </field-project-select>
              </div>
              <div class="mb-2">
                <field-location-select                 
                  titleLabel="Location*"
                  :isEditing="true"
                  :options="destinationLocationList[delivery.destinationProject._id]"
                  :value="delivery.destinationLocation"
                  v-model="delivery.destinationLocation"
                  :currentProjectId="delivery.sourceProject._id"
                  :deliveryProjectId="delivery.destinationProject._id"
                  @update:value="(val)=> delivery.destinationLocation = val"
                ></field-location-select>
              </div>
              <div>
                <field-user-select
                titleLabel="Recipient*"
                :isEditing="true"
                :options="recipientList"
                v-model="recipient"
                :value="recipient"
                :key="recipientList.length"
                @update:value="(val)=> recipient = val"
              ></field-user-select>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 px-5">
          <h4 class="is-size-3 is-italic has-text-weight-semibold">
            Delivery Details
          </h4>
        </div>
        <div class="column pt-0">
          <div class="columns">
            <div class="column">
              <div class="field">
                <div class="field-label">
                  <label class="label is-size-3 is-italic has-text-weight-semibold"> Delivery Name* </label>
                </div>
                <div class="field-body">
                  <div class="control">
                      <input class="input" v-model.trim="deliveryName"
                        placeholder="Enter name (3 or more characters)">
                    </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns">
                <div class="column">
                  <field-date
                    label="Ship By"
                    :isEdit="true"
                    :item="delivery"
                    :inputProps="getDateProps('deliveryStart')"
                    @set-date="(val)=> delivery.shipbyDate = val"
                    :isEmptyShip="true"
                    >
                  </field-date>
                </div>
                <div class="column">
                  <field-date
                    label="Deliver By*"
                    :isEdit="true"
                    :item="delivery"
                     :inputProps="getDateProps('deliverBy')"
                    @set-date="(val)=> delivery.deliveryDate = val"
                    :isEmptyShip="true"
                    >
                  </field-date>
                </div>
              </div>            
            </div>           
          </div>
        </div>
        <!-- inventory table start here -->
         <div class="column" v-if="$store.state.activeScreen === 'inventory'">
          <div class="columns">
            <div class="column" id="table-view">
                <mf-table
                  ref="inventoryShipTable"
                  :tableProps="tableProps"
                  :loadData="loadData"
                  :apiMode="true"
                  @cell-clicked="onCellClicked"
                  :key="rerenderMfTable"
                >
                  <template v-slot:qty-needed="{rowData: item }">
                    <qty-input
                      :max="item.available > QtyOptions.QTY_MAX ? QtyOptions.QTY_MAX : item.available" :roundTo="4"
                      v-model.number="item.qtyNeeded"
                      :value="item.qtyNeeded"
                      @update:value="itemQtyChanged($event, item)">
                    </qty-input>
                  </template>
                </mf-table>
            </div>
          </div>
         </div>
      </div>
      <footer class="modal-card-foot is-justify-content-flex-end is-align-items-center"
      v-if="!loadTemplateOrders">
      <div class="column is-narrow ">       
            <div>
              <button class="button is-outlined" @click="$emit('close')">
                Cancel
              </button>
              <button class="button  has-background-black-bis" @click="create(false)" :disabled="disableSave" >
                Create Order
              </button>
              <button class="button  has-background-black-bis" @click="create(true)" :disabled="disableSave" >
                Create/Edit Order
              </button>
            </div>
          </div>
      </footer>
    </div>
  </component>
  <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
</template>
<script>
import {
  reactive, toRefs, computed, onMounted, ref, defineAsyncComponent,
} from 'vue';
import { BaseOrder } from '@/models/BaseOrder';
import MfDate from '@/components/abstract/MfDate.vue';
import _, { isUndefined, flatMap, cloneDeep, filter, create } from 'lodash';
import { useStore } from 'vuex';
import { v4 as uuid } from 'uuid';
import Projects from '@/models/Projects';
import { useToast } from 'vue-toastification';
import StageField from '@/components/fields/StageField.vue';
import LocationSelect from '@/components/fields/LocationSelect.vue';
import moment from 'moment';
import Locations from '@/models/Locations';
import UtilityMixin from '../mixins/UtilityMixin';
import ProjectSelect from '@/components/fields/ProjectSelect.vue';
import { useRouter, useRoute } from 'vue-router';
import Users from '@/models/Users';
import MfFileList from '@/components/card-edit/CardFileList.vue';
import Shipping from '@/models/Shipping';
// import { driver } from 'localforage';
// import tableDefinition from '@/components/table-cols/inventoryCols';
import QtyInput from '@/components/fields/QtyInput.vue';
import QtyOptions from '../utils/QtyOptions';
const MfTable = defineAsyncComponent(() => import('@/components/table-fields/MfTable.vue'));

export default ({
  name: 'createEmptyShippingLabel',
  emits: ['close', 'on-save'],
  props: ['items', 'isActive', 'onSubmit', 'modalProgrammatic', 'currentProject', 'currentLocation'],
  components: {
  'mf-date': MfDate,
  StageField,
  ProjectSelect,
  LocationSelect,
  'mf-file': MfFileList,
  MfTable,
  QtyInput,
  },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();
    const inventoryShipTable = ref(null);
    const router = useRouter();
    const route = useRoute();
    const { getAllLocations } = UtilityMixin();
    const state = reactive({
      isLoading: true,
      createEmptyShippingLabel: false,
      allUsers: [],
      destUsers: [],
      orderName: '',
      allLocations: [],
      purpose: 'general',
      fromModal: true,
      project: {},
      shipType: '',
      forBOM: false,
      delivery: {
        sourceProject: {},
        sourceLocation: {},
        destinationProject: {},
        destinationLocation: {},
        shipbyDate: '',
        deliveryDate: '',
        alsoNotify: [],
      },
      owner: '',
      deliveryName: '',        
      recipient: '',        
      commonStockProject: {},
      sourceProjectList: [],
      sourceLocationList: [],
      destinationProjectList: [],
      destinationLocationList:[],
      recipientList:{},
      ownerList: [],
      tableProps: {},
      mfDateProps: {
        deliveryStart: {
          kind: 'deliveryStart',
          max: ['deliveryDate'],
        },
        deliverBy: {
          kind: 'deliverBy',
          min: ['shipbyDate'],
        },
      },
    });
    const inventoryFields = {
      defaultSortField: 'name',
      defaultSortOrder: 'asc',
      customRowKey: 'uid',
      fields: [
        {
          title: 'Inventory Items',
          name: 'field-generic-input',
          sortField: 'name',
          prop: 'name',
          width: '400px',
          sticky: true,
          id: 'name',
          isClickable: false,
          defaultVisible: true,
          alwaysVisible: true,
          searchField: false, // to give a search bar for the field
          searchable: false, // to place any custom field in the header of the column like for below
          bulkActionButtonField: false,   
        },
        {
          name: 'catId',
          width: '152px',
          title: 'Catalog ID',
          id: 'catId',
          prop: 'catId',
          allowAutoComplete: true,
          verifyCatId: true,
          sortField: 'catId',
        },{
          title: 'QTY In Stock',
          name: 'available',
          width: '152px',
          id: 'available',
          prop: 'available',
          sortField: 'available',
        },
        {
          name: 'qty-needed',
          prop: 'quantity',
          width: '112px',
          title: 'Qty Needed',
          id: 'quantity',
          inputProps: {
            type: 'text',
          },
        },
      ]
    };
    const getDateProps = ((dateType) => {
      if (!isUndefined(state.mfDateProps[dateType])) return {...state.mfDateProps[dateType], pos: 'top-right' };
      return { kind: dateType };
    });
    const create = async (isEditOrder=false) => {
      state.isLoading = true;
      try {
        const params = {
          orderName: state.orderName,
          owner: state.owner,
          recipient: state.recipient,
          sourceProject: state.delivery.sourceProject,
          delivery: state.delivery,
          deliveryName: state.deliveryName,
          isEditOrder,
          items: props.items,
        }
        await props.onSubmit(params);
        emit('close');
      }catch (err) {
        console.error('err', err);
      } finally {
        state.isLoading = false;
      }
    };
    const setSourceProject  = async (val) => {
      state.isLoading = true;
      try {
        _.set(state.delivery, 'sourceProject', val);
        state.destinationProjectList = [];
        state.delivery.sourceLocation = {};
        state.delivery.destinationProject = {};
        state.delivery.destinationLocation = {};
        // Load all projects
        state.allProjects = store.state.queryParams || [];
        if (!state.allProjects.length) {
          const projects = await Projects.allProjects();
          state.allProjects = flatMap(projects);
        }
        // Load common stock project
        if (_.isEmpty(state.commonStockProject)) {
          let { commonStockProject } = store.state.queryParams;
          state.commonStockProject = !_.isEmpty(commonStockProject)
            ? commonStockProject : await Projects.getCommonStockProject();
        }
        // If source is common stock, exclude common stock from destination list
        if (val._id === state.commonStockProject._id) {
          state.destinationProjectList = state.allProjects.filter(p => p._id !== state.commonStockProject._id);
        }
       
        // Ensure source project is included without duplicates
        if (state.delivery.sourceProject && state.delivery.sourceProject._id !== state.commonStockProject._id) {
           state.destinationProjectList.push(state.delivery.sourceProject);
           state.destinationProjectList.push(state.commonStockProject);
        }
        // Load source locations
        state.sourceLocationList = [];
        const allLocs = await getAllLocations(state.delivery.sourceProject._id, true);
        const locs = Locations.groupLocations(
          allLocs,
          store.state.companyData,
        );
        if (locs.length) {
          state.sourceLocationList[state.delivery.sourceProject._id] = locs;
        }
        await getRecipientList(state.delivery.sourceProject._id.toString());
        getOwnerList();
      } catch (err) {
        console.error('err', err);
      } finally {
        state.isLoading = false;
      }
      
    };
    
    const setDestinationProject = async (val) => {
      state.isLoading = true;
      try {
        _.set(state.delivery, 'destinationProject', val);
        state.destinationLocationList = [];
        state.delivery.destinationLocation = {};
        const allLocs = await getAllLocations(state.delivery.destinationProject._id, true);
        const partitionedLocs = _.partition(allLocs, (loc) => loc.nestedLocation)[+(state.delivery.destinationProject._id
                !== store.state.queryParams.commonStockProject._id)];
        const locs = Locations.groupLocations(
          partitionedLocs,
          store.state.companyData,
        );
        if (locs.length) {
          state.destinationLocationList[val._id] = locs;
        }
      } catch(err) {
        console.error('err', err);
      } finally {
        state.isLoading = false;
      }
    };

    const getRecipientList = async (projectId) => {
      let allUsers = await Projects.linkedProjectUsers([projectId]);
      allUsers = filter(allUsers, (usr) => usr.company.toString() === store.state.userData.company)
      state.recipientList = Users.groupUsers(allUsers);
    };
    const getOwnerList = () => {    
      if (state.delivery?.sourceProject._id
        === store.state.commonStockProject) {
        state.ownerList = state.recipientList;
      } else {
        state.ownerList = state.recipientList;
      }
    };
    onMounted(async () =>{
      state.tableProps = inventoryFields;
      try {
        if (props.currentProject) {
          setSourceProject(props.currentProject);
          getProjectLocation();
        }
        if (props.currentLocation) getCurrentLocation();
        let { commonStockProject } = store.state.queryParams;
          state.commonStockProject = !_.isEmpty(commonStockProject)
        ? commonStockProject : await Projects.getCommonStockProject();
      } catch(err) {
        console.error('err', err);
      } finally {
        state.isLoading = false;
      }
    });
    // Basic set of validations.
    const validation = () => {
      return  _.isEmpty(state.orderName) || state.orderName.length < 3 ||
        (_.isEmpty(state.deliveryName) || state.deliveryName.length < 3) ||
        (_.isEmpty(state.delivery.sourceProject) || state.delivery.sourceProject.length < 0) ||
        (_.isEmpty(state.delivery.sourceLocation) || state.delivery.sourceLocation.length < 0) ||
        (_.isEmpty(state.owner) || state.owner.length < 0) ||
        (_.isEmpty(state.delivery.destinationProject) || state.delivery.destinationProject.length < 0) ||
        (_.isEmpty(state.delivery.destinationLocation) || state.delivery.destinationLocation.length < 0) ||
        (_.isEmpty(state.recipient) || state.recipient.length < 0) ||
        (_.isEmpty(state.delivery.deliveryDate) || state.delivery.deliveryDate.length < 0)
    }
    const disableSave = computed(() => {
      // Basic set of validations.
      if (validation())
        return true;
    });

    const disabledFromInv = computed(() => {
      if(!_.isEmpty(props.currentProject)) return true;
      return false;
    })

    const getProjectLocation = async () => {
      if (props.currentProject) {
        await getRecipientList(props.currentProject._id.toString());
        getOwnerList();
        _.set(state.delivery, 'sourceProject', props.currentProject);
      }
      return state.delivery.sourceProject;
    };
    const getCurrentLocation = () => {
      if(props.currentLocation) {
        _.set(state.delivery, 'sourceLocation', props.currentLocation);
      }
      return state.delivery.sourceLocation;
    };
    const loadData = async (commonParam) => {
      const items = props.items;
      for (let item of items) {
        if (!item.qtyNeeded) item.qtyNeeded = 1;
      }
      return { data: items, total: items.length };
    };
    const itemQtyChanged = ((newQty, item) => {
      item.selected = newQty;
      const res = _.find(props.items, (i) => {
        if (_.isEmpty(item.catId)) return item.uid === i.uid;
        else return item.catId === i.catId;
      })
      if (!_.isEmpty(res)) res.qtyNeeded = newQty || 1;
    });
    return {
      ...toRefs(state),
      getDateProps,
      setSourceProject,
      setDestinationProject,
      disableSave,
      create,
      inventoryShipTable,
      loadData,
      disabledFromInv,
      getProjectLocation,
      getCurrentLocation,
      QtyOptions,
      itemQtyChanged
    };
  },
})
</script>
<style scoped>
::v-deep(#table-view .mf-table .o-table__wrapper){
  min-height: 23vh !important;
  max-height: 23vh !important;
}
::v-deep(#table-view .mf-table){
  margin-top: 0;
}
.modal-card-head {
    background-color: #fff !important;
    border-bottom: none !important;
  }
  .modal-card-foot {
    border-top: 1px solid #84888c;
     background-color: #fff !important;
  }
</style>